module.exports = __webpack_public_path__ + "media/images/bh-sun-b54eaa72739165c3b4b6f845d1c396d3.svg";